import { ColumnDef } from '@tanstack/react-table';
import { GetMyRefferals } from 'services/openapi';
import { normalizedPhoneNumber } from 'utils/helpers/helpers';

export const columnsDefined: ColumnDef<GetMyRefferals>[] = [
  {
    accessorKey: 'phoneNumber',
    header: 'Tài khoản',
    cell: (info) => normalizedPhoneNumber(String(info.getValue())),
  },
  {
    accessorKey: 'fullName',
    header: 'Tên tài khoản',
  },
  {
    accessorKey: 'compName',
    header: 'Hợp tác xã',
  },
  {
    accessorKey: 'email',
    header: 'Email',
  },
];
